import { Box, styledComponent } from '@hermes/web-components'

export const NoSellersFoundContainer = styledComponent(Box)(({ theme }) => ({
  padding: '17px 0',
  marginTop: '64px',
  paddingBottom: '300px',
  '.MuiTypography-root': {
    textAlign: 'center',
    '&:first-of-type': {
      lineHeight: '32px',
      fontWeight: 700,
      marginBottom: '8px'
    },
    '&:last-of-type': {
      fontSize: '14px',
      lineHeight: '20px',
      color: theme.palette.neutral.main
    }
  },
  [theme.breakpoints.down('xs')]: {
    marginTop: '182px'
  }
}))
